
const projectConfig = {

    projects: [
    {
      id: 1,
      image: 'Dmart.png',
      alt: 'Design conferences in 2022',
      // category: 'Design',
      // date: '2024-10-25',
      title: 'D-Mart Clone',
      text: 'A clone of the DMart website, showcasing an e-commerce platform with responsive design.',
      link: 'https://github.com/Abdullaabdulazeez/Syntax-Saadhana-2345',
    },
    {
      id: 2,
        image: 'weekend_planner.png',
      alt: 'Design conferences in 2022',
      // category: 'Design',
      // date: '2024-10-25',
      title: 'Weekend Planner',
      text: 'A React app for planning and managing weekend trips with user authentication and data visualization.',
      link: '"https://github.com/rmauryaa/-Samsung-Saviors_058"',
    },
    {
      id: 3,
      image: 'Viatours.png',
      alt: 'Design conferences in 2022',
      // category: 'Design',
      // date: '2024-10-25',
      title: 'Viatours',
      text: 'A responsive recreation of Viatours’ interface using HTML and CSS, mirroring the original Figma design.',
      link: 'https://github.com/Abdullaabdulazeez/Syntax-Saadhana-2345',
    },
  ],
}

export default projectConfig;